module.exports = __webpack_public_path__ + "img/7b955836dca6bd82621ac3f8863e0ee8.png";